// extracted by mini-css-extract-plugin
export default {"imageWrapper":"aI-z","twoColumnImage":"bI-z"};